import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.event-space-slider__splide' ).length ) {
        const sliders = [];
        $( '.event-space-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 3,
            focus: 'center',
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );

          const splideNav = slider.root.querySelector( '.event-space-slider__splide-nav' );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
              focus: 0,
            };
            if ( !isOverflow ) {
              splideNav.style.display = 'none';
            } else {
              splideNav.style.display = 'flex';
            }
          } );

          slider.mount();

          const sliderId = $( this ).attr( 'id' );
          sliders[sliderId] = slider;
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'event-space-slider', COMPONENT );
} )( app );
